import React, { Component, isValidElement, cloneElement } from "react";
import { Radio } from "antd";

import WeaInput from "../wea-input";
import WeaInputNumber from "../wea-input-number";
import WeaTextarea from "../wea-textarea";
import WeaSelect from "../wea-select";
import WeaBrowser from "../wea-browser";
import WeaDatePicker from "../wea-date-picker";
import WeaTimePicker from "../wea-time-picker";
import WeaTimeRangePicker from "../wea-time-range-picker";
import WeaColorPicker from "../wea-color-picker";
import WeaCheckbox from "../wea-checkbox";
import WeaCascader from "../wea-cascader/index.js";
import WeaError from "../wea-error";
import WeaLocaleProvider from "../wea-locale-provider";
import isFunction from "lodash/isFunction";
import isEqual from "lodash/isEqual";
import WindowFunc from "../wea-tools/window";

const { formatMultiLang } = WeaLocaleProvider;

class TableCellSingle extends React.PureComponent {
  onChange = value => {
    const {
      tableCellRecord,
      tableCellIndex,
      tableCellKey,
      onTableCellChange,
      tableCellType,
      tableCellCol
    } = this.props;
    if (typeof onTableCellChange === "function") {
      if (tableCellType === "CHECKBOX" || tableCellType === "SWITCH") {
        onTableCellChange({
          record: tableCellRecord,
          index: tableCellIndex,
          key: tableCellKey,
          value,
          type: tableCellType,
          col: tableCellCol
        });
      } else if (tableCellType === "RADIO") {
        onTableCellChange({
          record: tableCellRecord,
          index: tableCellIndex,
          key: tableCellKey,
          value: value.target.checked,
          type: tableCellType,
          col: tableCellCol
        });
      } else {
        onTableCellChange({
          record: tableCellRecord,
          index: tableCellIndex,
          key: tableCellKey,
          value,
          type: tableCellType
        });
      }
    }
  };
  onBrowserChange = (ids, names, browserDatas) => {
    const {
      tableCellRecord,
      tableCellIndex,
      tableCellKey,
      onTableCellChange,
      tableCellType
    } = this.props;
    typeof onTableCellChange === "function" &&
      onTableCellChange({
        record: tableCellRecord,
        index: tableCellIndex,
        key: tableCellKey,
        value: ids,
        names,
        browserDatas,
        type: tableCellType
      });
  };
  render() {
    const {
      tableCellType,
      tableCellRecord,
      tableCellIndex,
      tableCellKey,
      tableCellCol,
      ...nextProps
    } = this.props;
    if (tableCellType === "INPUTNUMBER") {
      return (
        <WeaInputNumber
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaInputNumber@g06orn`}
        />
      );
    } else if (tableCellType === "TEXTAREA") {
      return (
        <WeaTextarea
          {...nextProps}
          onBlur={this.onChange}
          ecId={`${this.props.ecId}_WeaTextarea@25uuhu`}
        />
      );
    } else if (tableCellType === "TIMEPICKER") {
      return (
        <WeaTimePicker
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaTimePicker@f3tvqy`}
        />
      );
    } else if (tableCellType === "TIMERANGEPICKER") {
      return (
        <WeaTimeRangePicker
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaTimeRangePicker@ms5f6x`}
        />
      );
    } else if (tableCellType === "DATEPICKER") {
      return (
        <WeaDatePicker
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaDatePicker@262cgq`}
        />
      );
    } else if (tableCellType === "SELECT") {
      return (
        <WeaSelect
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaSelect@o1yseu`}
        />
      );
    } else if (tableCellType === "BROWSER") {
      return (
        <WeaBrowser
          {...nextProps}
          onChange={this.onBrowserChange}
          ecId={`${this.props.ecId}_WeaBrowser@tjtg3s`}
        />
      );
    } else if (tableCellType === "CHECKBOX" || tableCellType === "SWITCH") {
      return (
        <WeaCheckbox
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaCheckbox@cqlvzk`}
        />
      );
    } else if (tableCellType === "CASCADER") {
      return (
        <WeaCascader
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaCascader@7hi0vu`}
        />
      );
    } else if (tableCellType === "CUSTOMFIELD") {
      return (
        <WeaCascader.WeaCustomField
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaCascader.WeaCustomField@1pty9c`}
        />
      );
    } else if (tableCellType === "COLORPICKER") {
      return (
        <WeaColorPicker
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_WeaColorPicker@cg4mbg`}
        />
      );
    } else if (tableCellType === "RADIO") {
      return (
        <Radio
          {...nextProps}
          onChange={this.onChange}
          ecId={`${this.props.ecId}_Radio@gvflj2`}
        />
      );
    }
    return (
      <WeaInput
        {...nextProps}
        onBlur={this.onChange}
        ecId={`${this.props.ecId}_WeaInput@sbpuqb`}
      />
    );
  }
}

export default class TableCell extends Component {
  static displayName = "TableCell";

  componentWillReceiveProps(nextProps) {
    const {
      validate: { pass, validateResult },
      com: { key },
      rowKey,
      record
    } = nextProps;
    if (
      pass === false &&
      key &&
      validateResult &&
      validateResult[key] &&
      validateResult[rowKey] === record[rowKey]
    ) {
      const error = this.refs[`error_${record[rowKey]}_${key}`];
      error && error.showError();
    }
  }

  shouldComponentUpdate(nextProps) {
    return true;
  }

  onEdit = values => {
    this.props.onEdit(values);
  };

  getBrowerDatas = (record, key) => {
    const replaceDatas = [];
    if (record[`${key}span`] !== void 0) {
      const keys =
        typeof record[key] === "string"
          ? record[key].split(",")
          : [record[key]];
      const values =
        typeof record[`${key}span`] === "string"
          ? record[`${key}span`].split(",")
          : [record[`${key}span`]];
      if (keys.length === values.length) {
        keys.forEach((k, i) => {
          k !== "" &&
            values[i] !== "" &&
            replaceDatas.push({ id: k, name: values[i] });
        });
      }
    }
    return replaceDatas;
  };

  createBrowser = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = this.getBrowerDatas(record, key);
    const { browserConditionParam = {} } = props;
    return (
      <TableCellSingle
        style={{ width: "100%", display: "inline-block" }}
        viewAttr={2}
        layout={WindowFunc.getTop().document.body}
        {...props}
        {...browserConditionParam}
        replaceDatas={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@o0t6j8@Browser_${index}`}
      />
    );
  };

  createCascader = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key];
    return (
      <TableCellSingle
        viewAttr={2}
        {...props}
        values={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@utqxhs@Cascader_${index}`}
      />
    );
  };

  createCustomField = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key];
    return (
      <TableCellSingle
        viewAttr={2}
        {...props}
        values={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@zhc615@CustomField_${index}`}
      />
    );
  };

  createCorlorPicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        viewAttr={2}
        {...props}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@0mugtm@CorlorPicker_${index}`}
      />
    );
  };

  createCheckbox = (props, type) => {
    const {
      com: { key },
      record,
      index,
      checkProps,
      col
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={checkProps.disabled ? 1 : 2}
        {...props}
        defaultValue={v}
        value={v}
        {...checkProps}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        tableCellCol={col}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@tlzyu1@Checkbox_${index}`}
      />
    );
  };

  createRadio = (props, type) => {
    const {
      com: { key },
      record,
      index,
      checkProps,
      col
    } = this.props;
    return (
      <TableCellSingle
        {...props}
        {...checkProps}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        tableCellCol={col}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@mazhlq@Radio_${index}`}
      />
    );
  };

  createSelect = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        viewAttr={2}
        options={[]}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@xzzy27@Select_${index}`}
      />
    );
  };

  createTimeRangePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || [];
    return (
      <TableCellSingle
        style={{ width: "45%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@negw0l@TimeRangePicker_${index}`}
      />
    );
  };

  createTimePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@3hub0b@TimePicker_${index}`}
      />
    );
  };

  createDatePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@k91ywz@DatePicker_${index}`}
      />
    );
  };

  createTextarea = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@46p6eb@Textarea_${index}`}
      />
    );
  };

  createInputNumber = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    let v = record[key] || "";
    if (record[key] === 0) {
      v = 0;
    }
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@633hzn@InputNumber_${index}`}
      />
    );
  };

  createInput = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <TableCellSingle
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        tableCellRecord={record}
        tableCellIndex={index}
        tableCellKey={key}
        tableCellType={type}
        onTableCellChange={this.onEdit}
        ecId={`${this.props.ecId}_TableCellSingle@1kffbx@Input_${index}`}
      />
    );
  };

  createCustom = () => {
    const { com, record, index, text, onEdit } = this.props;
    return com.render(text, record, index, onEdit);
  };

  createText = () => {
    const { com, text, index } = this.props;
    return (
      <span
        className={`wea-table-edit-html ${com.className || ""}`}
        dangerouslySetInnerHTML={{ __html: formatMultiLang(text) }}
        ecId={`${this.props.ecId}_TableCellSingle@bqbrm7@Text_${index}`}
      />
    );
  };

  getWeaComponent() {
    const { com } = this.props;
    const { type, otherParams = {} } = com;
    const t = typeof type === "string" ? type.toUpperCase() : "INPUT";
    // com props
    let props = { ...com };
    delete props.type;
    delete props.key;
    delete props.label;
    delete props.otherParams;
    delete props.error;
    // otherParams props
    props = { ...props, ...otherParams };
    // dispath
    switch (t) {
      case "INPUT":
        return this.createInput(props, t);
      case "INPUTNUMBER":
        return this.createInputNumber(props, t);
      case "TEXTAREA":
        return this.createTextarea(props, t);
      case "DATEPICKER":
        return this.createDatePicker(props, t);
      case "TIMEPICKER":
        return this.createTimePicker(props, t);
      case "TIMERANGEPICKER":
        return this.createTimeRangePicker(props, t);
      case "SELECT":
        return this.createSelect(props, t);
      case "BROWSER":
        return this.createBrowser(props, t);
      case "CHECKBOX":
        return this.createCheckbox(props, t);
      case "SWITCH":
        return this.createCheckbox({ ...props, display: "switch" }, t);
      case "RADIO":
        return this.createRadio(props, t);
      case "CASCADER":
        return this.createCascader(props, t);
      case "CUSTOMFIELD":
        return this.createCustomField(props, t);
      case "COLORPICKER":
        return this.createCorlorPicker(props, t);
      case "CUSTOM":
        return this.createCustom();
      case "TEXT":
        return this.createText();
      default:
        return null;
    }
  }
  onIconEnlargeClick = () => {
    const { rowKey, index, record, doAdd, onRowAdd } = this.props;
    isFunction(doAdd) && doAdd(record[rowKey]);
    isFunction(onRowAdd) && onRowAdd(record, index);
  };
  // wrap WeaError
  wrapWeaComponent = () => {
    const {
      com: { key, isTreeNode, viewAttr },
      len,
      rowKey,
      index,
      validate: { validateResult },
      record,
      lastTreeNode,
      operationKey
    } = this.props;
    const error =
      validateResult && validateResult[key] ? validateResult[key][0] : "";
    const dotIndex = record[rowKey].toString().split(".").length - 1;
    let paddingLeft = 20 * dotIndex,
      left = 20 * (dotIndex - 1);
    paddingLeft < 0 && (paddingLeft = 0);
    left < 0 && (left = 0);
    const com = isTreeNode ? (
      <div
        style={{ position: "relative", paddingLeft: paddingLeft }}
        ecId={`${this.props.ecId}_div@3yraq6@${index}`}
      >
        {dotIndex !== 0 && (
          <i
            className={`${
              lastTreeNode ? "icon-coms-line-2" : "icon-coms-line-1"
            }`}
            style={{
              fontSize: 18,
              color: "#979797",
              position: "absolute",
              left,
              top: 4
            }}
            ecId={`${this.props.ecId}_i@btn3zs@${index}`}
          />
        )}
        <WeaError
          ref={`error_${record[rowKey]}_${key}`}
          error={error}
          style={{ paddingRight: 20, width: "100%" }}
          tipPosition={len === index + 1 ? "top" : "bottom"}
          ecId={`${this.props.ecId}_WeaError@mqv451@${index}`}
        >
          {this.getWeaComponent()}
        </WeaError>
        {record[operationKey] && (
          <i
            className="icon-coms-Enlarge"
            style={{
              position: "absolute",
              fontSize: 15,
              color: "#979797",
              top: viewAttr === 1 ? 4 : 7,
              right: -8,
              cursor: "pointer"
            }}
            onClick={this.onIconEnlargeClick}
            ecId={`${this.props.ecId}_i@ajn02t@${index}`}
          />
        )}
      </div>
    ) : (
      <WeaError
        ref={`error_${record[rowKey]}_${key}`}
        error={error}
        tipPosition={len === index + 1 ? "top" : "bottom"}
        ecId={`${this.props.ecId}_WeaError@fd5vvo@${index}`}
      >
        {this.getWeaComponent()}
      </WeaError>
    );
    return com;
  };

  // tableCellProps
  wrapReactComponent = () => {
    const { com, record, index, text, onEdit } = this.props;
    return cloneElement(com, {
      tableCellProps: { record, index, text, onEdit }
    });
  };

  render() {
    const { com, rowKey, record, index } = this.props;
    if (isValidElement(com)) {
      return this.wrapReactComponent();
    }
    const { label = "", key, type, hasHiddenField } = com;
    // hidden field
    const hiddrenField = (
      <input
        id={`${key}_${record[rowKey]}`}
        type="hidden"
        value={record[key]}
        ecId={`${this.props.ecId}_input@gid7gu@${index}`}
      />
    );
    if (typeof type === "string" && type.toUpperCase() === "HIDDENFIELD") {
      return hiddrenField;
    }
    return (
      <span>
        {label ? <span style={{ marginLeft: 5 }}>{label}</span> : null}
        {this.wrapWeaComponent()}
        {hasHiddenField ? hiddrenField : null}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/TableCell.js